@use 'src/globals/main';

pn-segmented-control {
  position: relative;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  border-radius: 3em;
  transform: translateZ(0);
  @include main.pn-transition('outline-color');
  @include main.pn-focus-base;

  &:focus-within,
  &:active {
    @include main.pn-focus-visible;
  }
}

pn-segmented-control .pn-segmented-control {
  display: flex;
  align-items: center;
  border-radius: 3em;
  min-height: 3em;
  padding: 0.25em;
  background: main.$gray50;
  position: relative;
  overflow-x: auto;
  scroll-snap-type: x mandatory;

  &:hover .pn-sc-bg[data-hover] {
    opacity: 1;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  .pn-sc-bg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    will-change: transform;
    left: 0;
    border-radius: inherit;
    @include main.pn-transition('width, transform, background-color, opacity, box-shadow');

    &[data-active] {
      box-shadow:
        0px 0.3px 0.9px rgba(0, 0, 0, 0.1),
        0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
      border: 0.0625em solid main.$blue700;
      background-color: main.$white;
      z-index: 1;
    }

    &[data-hover] {
      background-color: main.$blue50;
      opacity: 0;
      border: 0.25em solid transparent;
      z-index: 0;
      &[data-disabled] {
        border-color: main.$gray100;
        background-color: main.$gray100;
      }
    }

    &[data-disabled] {
      border-color: main.$gray100;
      background-color: main.$gray100;
    }
  }
}

/*---------------------------------------ARROWS-------------------------------------------*/
pn-segmented-control .pn-sc-arrows {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;

  svg {
    width: 1.5em;

    &.pn-icon-svg path {
      fill: main.$blue700;
    }
  }

  > .pn-sc-arrow {
    cursor: pointer;
    pointer-events: all;

    width: 2.5em;
    height: 2.5em;

    background: main.$white;
    border: none;
    outline: none;

    display: flex;
    align-items: center;
    justify-content: center;

    opacity: 0;
    will-change: transform;
    -webkit-tap-highlight-color: transparent;

    @include main.pn-transition('transform, opacity, background-color, box-shadow');

    &.pn-sc-arrow-left {
      transform: translateX(-100%);
      border-radius: 0 50% 50% 0;
      padding: 0 0.3em 0 0;
      box-shadow: 0.2rem 0.3rem 0.2rem rgba(0, 0, 0, 0.4);
    }

    &.pn-sc-arrow-right {
      transform: translateX(100%);
      border-radius: 50% 0 0 50%;
      box-shadow: -0.2rem 0.3rem 0.2rem rgba(0, 0, 0, 0.4);
    }
  }

  &.pn-sc-left-visible .pn-sc-arrow-left,
  &.pn-sc-right-visible .pn-sc-arrow-right {
    opacity: 1;
    transform: translateX(0);
  }
}
/*---------------------------------------/ARROWS-------------------------------------------*/
